/**
 * Endpoints del item (`/ranch/...`), iguales en los backends de Zurich y tasaciones
 * (relativos a `${VUE_APP_BACKEND}/web/api/`).
 */
export enum ItemUrls {
   RANCH = '/ranch/',
   RANCH_AREA = '/ranch/area/',
   RANCH_LIST = '/ranch/list/',
   RANCH_LIST_OPTIONS = '/ranch/list/options/',
   FARMING_LIST = '/farming/list/',
   PROCESS_FILE = '/ranch/files/'
}
